/* 专题广告 */
<template>
  <div id="topic">
    <div v-for="(item, index) in tableData" :key="index" class="item" @click="advertisingClick(item)">
      <div>广告位{{ index + 1 }}</div>
      <img :src="mixinQiniuImg(item.coverImg)">
      <div>
        <template v-if="item.jumpType">
          {{ item.jumpTo ? '跳转' : 'ㅤ' }}
          {{
            new Map([
              [1, `小程序：${item.jumpTo}`],
              [2, `网页： ${item.jumpTo}`],
              [3, ` ${item.jumpTo}`],
              [5, `线路班次`],
              [6, `营销活动页面`]
            ]).get(item.jumpType)
          }}</template>
      </div>
    </div>

    <div v-if="tableData.length < 6" class="add" @click="visible = true">
      <div>+</div>
      <div>创建广告位</div>
    </div>

    <el-drawer :visible.sync="visible" :before-close="advertisingClose">
      <topicForm :visible.sync="visible" :id="id" @advertisingClose="advertisingClose" />
    </el-drawer>
  </div>
</template>

<script>

export default {
  name: "topic",
  components: {
    topicForm: () => import("./topicForm")
  },

  data() {
    return {
      tableData: [],

      id: null,
      visible: false
    }
  },

  created() {
    this.getTable()
  },

  methods: {
    async getTable() {
      let url = "/api/v1//manage/banner/top"
      let res = await this.$axios.get(url)
      if (res.code == 1) {
        this.tableData = res.data;
      }
    },
    advertisingClick(row) {
      this.visible = true;
      this.id = row.id;
    },
    advertisingClose() {
      this.visible = false;
      this.id = null;
      this.getTable();
    }
  }
}
</script>

<style lang="less">
#topic {
  padding: 6px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 50px;
  grid-row-gap: 50px;

  .item {
    min-height: 350px;
    max-height: 400px;
    padding: 15px 20px;
    box-sizing: border-box;
    border: 5px#f2f2f2 solid;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: space-between;

    img {
      width: 100%;
      margin: 10px 0;
    }

    &>div:nth-child(1) {
      font-size: 20px;
    }

    &>div:nth-child(3) {
      width: 22vw;
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .add {
    min-height: 350px;
    max-height: 400px;
    border: 5px#f2f2f2 solid;
    box-sizing: border-box;
    color: #999;
    cursor: pointer;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    &>div:nth-child(1) {
      line-height: 60px;
      font-size: 60px;
    }
  }
}
</style>
